module.exports = __webpack_public_path__ + "media/images/about-2659550a525f318df911b90f6668ac45.jpg";